/** Aligné sur backend/services/b2b/b2bEligibility.js */

const EXCLUDED_TYPES = new Set([
  'PAR_PERSONNE',
  'PAR_POIDS',
  'PLATEAU_COMPOSE',
  'MENU_COMBO',
]);

export function isB2bV1CompatibleProductForm(formData = {}) {
  if (formData.typeProduit === 'GIFT_CARD' || formData.typeProduit === 'SERVICE') return false;
  if (formData.venteAuPoids) return false;
  if (formData.modeComposition) return false;
  if (formData.isPlateauParPersonne) return false;
  const pt = formData.productType || null;
  if (pt && EXCLUDED_TYPES.has(pt)) return false;
  return true;
}

/**
 * Champ tarif PRO à inclure dans le payload produit.
 * B2B désactivé : ne rien envoyer (y compris une valeur historique affichée).
 * B2B activé : null si vide, sinon le prix converti.
 * @returns {Record<string, number|null>}
 */
export function buildPrixProHtSaveField(moduleB2bEnabled, prixProHtRaw, convertPrice) {
  if (!moduleB2bEnabled) return {};
  if (prixProHtRaw === '' || prixProHtRaw == null) return { prixProHt: null };
  const converted = typeof convertPrice === 'function' ? convertPrice(prixProHtRaw) : prixProHtRaw;
  return { prixProHt: converted };
}

export function previewProTtc(ht, tauxTVA = 20) {
  const n = parseFloat(String(ht ?? '').replace(',', '.'));
  if (!Number.isFinite(n) || n < 0) return null;
  const rate = Number(tauxTVA);
  if (!Number.isFinite(rate) || rate <= 0) return Number(n.toFixed(2));
  return Number((n * (1 + rate / 100)).toFixed(2));
}
